import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/products`;

export const getProducts = async () => {
  const url = `${baseRoute}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getProductOptions = async (options = {}) => {
  const q = queryString.stringify(options);
  const url = `${baseRoute}/options?${q}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getQaUserPermissions = async () => {
  const url = `${baseRoute}/permissions`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};